import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../../components/SEO';

export default function ThankYou() {
  return (
    <>
    <SEO 
      title="Thank You - Request Received"
      description="Thank you for your request! Our team will contact you shortly to schedule your personalized tutoring session."
      url="/thank-you"
      type="website"
      noIndex={true}
      og={{
        type: 'website',
        siteName: 'WorldoTutor',
        locale: 'en_US',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Thank You - WorldoTutor',
          width: 1200,
          height: 630
        }
      }}
      twitter={{
        card: 'summary_large_image',
        site: '@worldotutor',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Thank You - WorldoTutor'
        }
      }}
    />
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center bg-white rounded-2xl shadow-xl p-8 md:p-12">
        <div className="mx-auto mb-6 w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
          <svg
            className="w-10 h-10 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-neutralBlack mb-3">Thank you!</h1>
        <p className="text-neutralGray2 mb-8">
          Your Free Trial request has been received. Our team will contact you shortly to schedule your session.
        </p>
        <div className="flex items-center justify-center gap-3">
          {/* <Link to="/find-tutor" className="inline-flex items-center justify-center px-5 py-3 rounded-lg bg-primary text-white hover:opacity-90 transition">Explore Tutors</Link> */}
          <Link
            to="/"
            className="inline-flex items-center justify-center px-5 py-3 rounded-lg border border-neutralGray4 text-neutralBlack hover:bg-neutralBlue2 transition"
          >
            Go Home
          </Link>
        </div>
      </div>
    </div>
    </>
  );
}
